// src/components/BenefitGrid.js
import React from 'react';

const BenefitGrid = ({ title, benefits }) => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-3xl font-bold tracking-tight text-dark-text-primary sm:text-4xl">
            {title}
          </h2>
        </div>
        <div className="mx-auto mt-16 grid max-w-none grid-cols-1 gap-8 text-center sm:mt-20 lg:grid-cols-4">
          {benefits.map((benefit) => (
            <div key={benefit.title} className="flex flex-col items-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-dark-accent-start to-dark-accent-end">
                <benefit.icon className="h-8 w-8 text-white" />
              </div>
              <h3 className="mt-5 text-xl font-semibold text-dark-text-primary">{benefit.title}</h3>
              <p className="mt-2 text-base text-dark-text-secondary">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitGrid;